// extracted by mini-css-extract-plugin
export var container = "_df-0";
export var infoIcon = "_df-2";
export var titleRowCol = "_df-1";